import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-right",
  "use": "arrow-right-usage",
  "viewBox": "0 0 43 24",
  "content": "<symbol viewBox=\"0 0 43 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"arrow-right\">\n<path d=\"M0.999443 11.8462L41.2852 11.8462\" stroke=\"currentColor\" stroke-width=\"1.71429\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n<path d=\"M30.439 22.6923L41.2852 11.8462L30.439 1\" stroke=\"currentColor\" stroke-width=\"1.71429\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol